import React, { useState, useEffect } from "react";
import { FaChevronUp } from "react-icons/fa";

const TopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 660) { // 160px kaydırıldıktan sonra görünür olacak
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-4 left-1 z-50">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="font-bold cursor-pointer text-3xl rounded-full bg-scrollColor p-3"
        >
          <FaChevronUp />
        </button>
      )}
    </div>
  );
};

export default TopButton;
